import { render, staticRenderFns } from "./AttachmentsInput.vue?vue&type=template&id=60247920&scoped=true&"
import script from "./AttachmentsInput.vue?vue&type=script&lang=js&"
export * from "./AttachmentsInput.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsInput.vue?vue&type=style&index=0&id=60247920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60247920",
  null
  
)

export default component.exports